import { gangDetectionService } from "../_services/gang.service";

export const gangDetectionAction = {
  AllocatedGangDetectionModule,
  AllocatedGangDetectionModuleList,
  AllocatedGagDetectionCityId,
  getGangPaginate,
  getGangDetails,
  updateGang,
  getGraph,
  getGangIdsFirs,
  GangMemberList,
};
function AllocatedGangDetectionModule(values) {
  return gangDetectionService.AllocatedGangDetectionModule(values);
}
function AllocatedGangDetectionModuleList() {
  return gangDetectionService.AllocatedGangDetectionModuleList();
}
function AllocatedGagDetectionCityId(cityId) {
  return gangDetectionService.AllocatedGagDetectionCityId(cityId);
}
function getGangPaginate(values) {
  return gangDetectionService.getGangPaginate(values);
}
function getGangDetails(values) {
  return gangDetectionService.getGangDetails(values);
}
function updateGang(values) {
  return gangDetectionService.updateGang(values);
}
function getGraph(values) {
  return gangDetectionService.getGraph(values);
}
function getGangIdsFirs(values) {
  return gangDetectionService.getGangIdsFirs(values);
}
function GangMemberList(value) {
  return gangDetectionService.GangMemberList(value);
}
